/**
 * GENERATED FILE — DO NOT EDIT.
 *
 * Emitted from OrbitalX.Business FieldLimitsService by api/Tools/OrbitalX.TypeGen.
 * Regenerate with `npm run generate-types` from dashboard/ and commit the result.
 * These values cover basic required and maximum-length checks. API validators remain
 * authoritative for business rules such as URL, country and postal-code formats.
 */
export const fieldLimits = {
  ClientCompany: {
    CompanyUrl: { MaxLength: 2083, IsRequired: true },
    Industry: { MaxLength: 100, IsRequired: false },
    Name: { MaxLength: 255, IsRequired: true },
    Size: { MaxLength: 100, IsRequired: false },
    Slug: { MaxLength: 50, IsRequired: true },
  },
  CompanyAddress: {
    BusinessName: { MaxLength: 200, IsRequired: true },
    City: { MaxLength: 50, IsRequired: true },
    PostalCode: { MaxLength: 20, IsRequired: true },
    RegionOrState: { MaxLength: 50, IsRequired: false },
    StreetAddress: { MaxLength: 100, IsRequired: true },
    StreetAddressLineTwo: { MaxLength: 100, IsRequired: false },
  },
  Demo: {
    DemoBenefitItem: { MaxLength: 200, IsRequired: false },
    DemoCalendlyUrl: { MaxLength: 500, IsRequired: false },
    DemoOverview: { MaxLength: 5000, IsRequired: false },
    DemoTitle: { MaxLength: 200, IsRequired: true },
  },
  Download: {
    DownloadBenefitItem: { MaxLength: 200, IsRequired: false },
    DownloadOverview: { MaxLength: 5000, IsRequired: false },
    DownloadTitle: { MaxLength: 200, IsRequired: true },
  },
  LandingPage: {
    BrandGuidelines: { MaxLength: 5000, IsRequired: false },
    MetaDescription: { MaxLength: 160, IsRequired: false },
    OgImageAlt: { MaxLength: 125, IsRequired: false },
    ToneOfVoice: { MaxLength: 5000, IsRequired: false },
    VisualNarrative: { MaxLength: 5000, IsRequired: false },
  },
  LandingPageTemplate: {
    Name: { MaxLength: 200, IsRequired: true },
  },
  Meeting: {
    MeetingBenefitItem: { MaxLength: 200, IsRequired: false },
    MeetingCalendlyUrl: { MaxLength: 500, IsRequired: false },
    MeetingOverview: { MaxLength: 5000, IsRequired: false },
    MeetingTitle: { MaxLength: 200, IsRequired: true },
  },
  OnlineEvent: {
    OnlineEventAgendaItem: { MaxLength: 2000, IsRequired: false },
    OnlineEventConferenceId: { MaxLength: 100, IsRequired: false },
    OnlineEventOverview: { MaxLength: 5000, IsRequired: false },
    OnlineEventTitle: { MaxLength: 200, IsRequired: true },
  },
  OnlineEventSpeaker: {
    SpeakerBio: { MaxLength: 4000, IsRequired: false },
    SpeakerCompanyId: { MaxLength: 64, IsRequired: false },
    SpeakerCompanyName: { MaxLength: 200, IsRequired: true },
    SpeakerEmail: { MaxLength: 254, IsRequired: true },
    SpeakerName: { MaxLength: 200, IsRequired: true },
    SpeakerTitle: { MaxLength: 200, IsRequired: true },
  },
  Quiz: {
    QuizAdvice: { MaxLength: 1500, IsRequired: false },
    QuizBandCopy: { MaxLength: 1500, IsRequired: false },
    QuizBandName: { MaxLength: 60, IsRequired: false },
    QuizButtonLabel: { MaxLength: 60, IsRequired: false },
    QuizButtonUrl: { MaxLength: 2048, IsRequired: false },
    QuizDimensionName: { MaxLength: 80, IsRequired: false },
    QuizDisclaimer: { MaxLength: 2000, IsRequired: false },
    QuizHelpText: { MaxLength: 300, IsRequired: false },
    QuizId: { MaxLength: 40, IsRequired: true },
    QuizNotApplicableLabel: { MaxLength: 80, IsRequired: false },
    QuizQuestionText: { MaxLength: 300, IsRequired: false },
    QuizReportSectionText: { MaxLength: 5000, IsRequired: false },
    QuizReportSectionTitle: { MaxLength: 120, IsRequired: false },
    QuizScaleLabel: { MaxLength: 60, IsRequired: false },
  },
  ThankYou: {
    CtaLabel: { MaxLength: 60, IsRequired: false },
    CtaUrl: { MaxLength: 2048, IsRequired: false },
    CustomMessage: { MaxLength: 160, IsRequired: false },
    DownloadUrl: { MaxLength: 2048, IsRequired: false },
    PostEventYouTubeUrl: { MaxLength: 2048, IsRequired: false },
    PreEventYouTubeUrl: { MaxLength: 2048, IsRequired: false },
  },
  Web: {
    WebDescription: { MaxLength: 5000, IsRequired: false },
    WebName: { MaxLength: 200, IsRequired: true },
  },
  Workspace: {
    Description: { MaxLength: 1000, IsRequired: false },
    Name: { MaxLength: 200, IsRequired: true },
    Slug: { MaxLength: 50, IsRequired: true },
    Website: { MaxLength: 2083, IsRequired: false },
  },
} as const
